export default __webpack_public_path__ + "static/media/referral_link_icon.20bdadf9.svg";